<template>
  <v-dialog
    scrollable
    :value="true"
    width="538px"
    @click:outside="$emit('close')"
  >
    <v-card class="pa-0 ma-0"
      ><v-card-title class="px-6 pt-4 pb-3 text-h6">{{
        $t('common.due_date')
      }}</v-card-title>

      <v-card-text class="px-6 pt-1 pb-0">
        <DueDatePicker
          isEditMode
          :dueDateTime="dueDate"
          @change="dueDate = $event"
        />
      </v-card-text>

      <v-card-actions class="px-6 py-4 justify-end">
        <Button
          plain
          :disabled="isLoading"
          :text="$t('common.button.cancel')"
          @click="$emit('close')"
        />

        <Button
          color="primary"
          :loading="isLoading"
          :disabled="disableSave"
          :text="$t('common.apply')"
          @click="editDueDate"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'
import api from '@/api'
import mixin from '@/mixins/mixin.vue'

import DueDatePicker from '@/components/DueDatePicker/DueDatePicker.vue'
import Button from '@/components/UI/Button'

export default {
  name: 'BulkEditDueDateModal',

  mixins: [mixin],

  props: {
    selectedFindings: {
      type: Array,
      default() {
        return []
      },
    },
  },

  components: {
    DueDatePicker,
    Button,
  },

  data() {
    return {
      dueDate: '',
      isLoading: false,
    }
  },

  computed: {
    ...mapGetters(['organizationId']),

    disableSave() {
      return _.isEmpty(this.dueDate) || this.isLoading
    },

    bulkEditText() {
      return this.$t('routines.findings_bulk_edit_success', {
        count: this.selectedFindings.length,
      })
    },
  },

  methods: {
    async editDueDate() {
      try {
        this.isLoading = true
        const findingsToEdit = this.selectedFindings.map(element => element._id)
        await api.findings.bulkEditDueDate({
          organizationId: this.organizationId,
          findingsIds: findingsToEdit,
          dueDate: this.dueDate,
        })
        this.showSuccess(this.bulkEditText)
        this.$emit('success')
      } catch (err) {
        this.handleRequestError(err)
        this.$emit('close')
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
